module.exports = __webpack_public_path__ + "static/img/360_mac_6.843c657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step/360_mac_6.png
// module id = 6Gp+
// module chunks = 94